import { render, staticRenderFns } from "./articleDetailDialog.vue?vue&type=template&id=6f141739"
import script from "./articleDetailDialog.vue?vue&type=script&lang=js"
export * from "./articleDetailDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports